import {
    RECEIVE_TAX_OFFICE_FISCAL_ADDRESS,
    RECEIVE_TAX_OFFICE_FISCAL_ADDRESS_ERROR,
    RECEIVE_TAX_OFFICE_REFERENCE_NUMBER,
    REQUEST_TAX_OFFICE_FISCAL_ADDRESS,
} from '../actions'
import { RequestStatus } from '../helpers/request'

export default (
    state = {
        fiscalAddress: {
            address: null,
            isAddressConfirmed: null,
            error: null,
            requestStatus: RequestStatus.IDLE,
        },
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_TAX_OFFICE_FISCAL_ADDRESS: {
            const { fiscalAddress } = state
            return {
                ...state,
                fiscalAddress: {
                    ...fiscalAddress,
                    ...data,
                    requestStatus: RequestStatus.PENDING,
                },
            }
        }

        case RECEIVE_TAX_OFFICE_FISCAL_ADDRESS: {
            const { fiscalAddress } = state
            return {
                ...state,
                fiscalAddress: {
                    ...fiscalAddress,
                    ...data,
                    requestStatus: RequestStatus.RESOLVED,
                },
            }
        }

        case RECEIVE_TAX_OFFICE_FISCAL_ADDRESS_ERROR: {
            const { fiscalAddress } = state
            return {
                ...state,
                fiscalAddress: {
                    ...fiscalAddress,
                    error: data,
                    requestStatus: RequestStatus.REJECTED,
                },
            }
        }

        case RECEIVE_TAX_OFFICE_REFERENCE_NUMBER: {
            return { ...state, referenceNumber: data }
        }

        default:
            return state
    }
}
